import { Text, Box } from "theme-ui";

import ModalCenter from "../ModalCenter";
import * as styles from "./ModalSimilarOptions.styles";

export default function ModalSimilarOptions({
  isTopMostModal,
  onClose,
  title,
  text,
}) {
  return (
    <ModalCenter onClose={onClose} isTopMostModal={isTopMostModal}>
      <Box sx={styles.contentContainer}>
        <Text variant="h4Light" sx={styles.modalTitle}>
          {title}
        </Text>
        <Box
          sx={styles.modalTextContent}
          dangerouslySetInnerHTML={{ __html: text }}
        ></Box>
      </Box>
    </ModalCenter>
  );
}
